import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const privatePartyInquiryFormDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.partyInquiry,
  componentType: LAYOUT_COMPONENT_TYPE.privatePartyInquiryForm,
  registryBlockKey: REGISTRY_BLOCK.presentation.privatePartyInquiryForm,
  displayOrder: 4,
  content: {
    heading: loc3('Private Party', 'Private party', 'Tiệc riêng'),
    supporting: loc3(
      'Geburtstage, Firmenevents und After-Work — wir planen mit.',
      'Birthdays, company events and after-work — we plan with you.',
      'Sinh nhật, sự kiện công ty và after-work — chúng tôi cùng lên kế hoạch.',
    ),
    ctaLabel: loc3('Anfrage senden', 'Send inquiry', 'Gửi yêu cầu'),
    note: loc3(
      'Antwort innerhalb von 24 Stunden.',
      'We reply within 24 hours.',
      'Phản hồi trong 24 giờ.',
    ),
  },
  media: {},
};

export const privatePartyInquirySalonDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.partyInquirySalon,
  componentType: LAYOUT_COMPONENT_TYPE.privatePartyInquiryForm,
  registryBlockKey: REGISTRY_BLOCK.presentation.privatePartyInquirySalon,
  displayOrder: 4,
  content: {
    heading: loc3('Privates Dinner', 'Private dining', 'Bữa tối riêng'),
    supporting: loc3(
      'Buyout, Chef’s Table oder Keller — Datum, Personen und Menüwunsch. Keine Abendtische und keine allgemeine Hausfrage.',
      'Buyout, chef’s table, or cellar — date, covers, and menu wish. Not for evening tables or a general house note.',
      'Đặt trọn nhà, chef’s table hoặc hầm — ngày, số khách và mong muốn menu. Không phải bàn tối hay tin nhắn chung.',
    ),
    ctaLabel: loc3('Anfrage senden', 'Send inquiry', 'Gửi yêu cầu'),
    note: loc3(
      'Antwort innerhalb von zwei Werktagen. Mindestanzahl auf Anfrage.',
      'We reply within two working days. Minimum covers on request.',
      'Trả lời trong hai ngày làm việc. Số khách tối thiểu theo yêu cầu.',
    ),
  },
  media: {
    salonImage:
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80',
  },
};
